import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColoresService {

  constructor() { }

  estilos(valores: any) {
    const stylesheet = document.styleSheets;
    const colores = stylesheet[0].cssRules[0] as unknown as HTMLElement;
    colores.style.setProperty('--color-principal', valores.color1, 'important');
    colores.style.setProperty('--color-secundario', valores.color3, 'important');
    colores.style.setProperty('--color-letras', valores.color2, 'important');
  }
}
